import React from "react";
import LazyByScroll from "../../../../components/LazyByScroll/LazyByScroll";
import { useDatalayerInit } from "../../../../hooks/useDatalayerInit";
import useDynatrace from "../../../../hooks/useDynatrace";
import useScrollToTop from "../../../../hooks/useScrollToTop";
import useWindowResize from "../../../../hooks/useWIndowResize";
import IntroSection from "../IntroSection/IntroSection";
import LazyCoverageInfoModal from "./LazyCoverageInfoModal";

const WhichEnsureSectionImport = () => import("../WhichEnsureSection");
const CalculatorSectionImport = () => import("../CalculatorSection");
const WhoCanHireSectionImport = () => import("../WhoCanHireSection");
const DiscountLegalSectionImport = () => import("../DiscountLegalSection");
const WhichEnsureSection = React.lazy(WhichEnsureSectionImport);
const CalculatorSection = React.lazy(CalculatorSectionImport);
const WhoCanHireSection = React.lazy(WhoCanHireSectionImport);
const DiscountLegalSection = React.lazy(DiscountLegalSectionImport);

const mobileComponents = (
    <>
        <LazyByScroll importCallback={WhichEnsureSectionImport} offset={-60} />
        <LazyByScroll importCallback={WhoCanHireSectionImport} offset={-60} />
        <LazyByScroll importCallback={CalculatorSectionImport} offset={-60} />
        <LazyByScroll importCallback={DiscountLegalSectionImport} offset={-60} />
    </>
);

const desktopComponents = (
    <>
        <WhichEnsureSection />
        <WhoCanHireSection />
        <CalculatorSection />
        <DiscountLegalSection />
    </>
);

const LandingPage = () => {
    const { isMobile } = useWindowResize();
    useDatalayerInit();
    useScrollToTop();
    useDynatrace();
    return (
        <div className="landing-page">
            <IntroSection />
            {isMobile ? mobileComponents : desktopComponents}
            <LazyCoverageInfoModal />
        </div>
    );
};

export default React.memo(LandingPage);
